import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Filter from '../../Filter';
import Pagination from '../../TablePagination';
import ReportDetail from './ReportDetail';
import { reportListFormatter } from '../../../lib/formatter';
import moment from 'moment';

const ReportList = ({
  reportListTotal,
  reportListItems,
  filterItem,
  paginationItem,
  currentPageNumber,
  listReportApi,
  exportDataToExcel,
  setFilterItem,
  setPaginationItem,
  setCurrentPageNumber,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenReportDetailModal, setIsOpenReportDetailModal ] = useState(false);
  const [ selectedReportItem, setSelectedReportItem ] = useState({});
  const reportTypeList = [
    { key: t('data.report_type.key_issue'), value: 'userkey' },
    { key: t('data.report_type.facility'), value: 'facility' },
    { key: t('data.report_type.staff'), value: 'staff' },
    { key: t('data.report_type.use_mobilekey'), value: 'user_mobilekey' },
  ];
  const reportTableConfig = {
    userkey: [
      { th: t('data_column.key_type'), td: 'key_type', width: '7%' },
      { th: t('data_column.content'), td: 'operation', width: '10%' },
      { th: t('data_column.building'), td: 'building_name', width: '9%' },
      { th: t('data_column.room'), td: 'json_destination.room', width: '7%' },
      { th: t('data_column.user_name'), td: 'grantee_name', width: '8%' },
      { th: t('data_column.phone_number'), td: 'grantee_phone_number', width: '8%' },
      { th: t('data_column.checkin_day'), td: 'start_at_day', width: '7%' },
      { th: t('data_column.checkin_hour'), td: 'start_at_hour', width: '4%' },
      { th: t('data_column.checkout_day'), td: 'end_at_day', width: '7%' },
      { th: t('data_column.checkout_hour'), td: 'end_at_hour', width: '4%' },
      { th: t('data_column.staff'), td: 'actor_name', width: '8%' },
      { th: t('data_column.sequence'), td: 'json_context.seq_num', width: '3%' },
      { th: t('data_column.created_at'), td: 'created_at', width: '10%' },
    ],
    facility: [
      { th: t('data_column.facility'), td: 'facility_name', width: '14%' },
      { th: t('data_column.building'), td: 'building_name', width: '14%' },
      { th: t('data_column.content'), td: 'operation', width: '30%' },
      { th: t('data_column.staff'), td: 'actor_name', width: '14%' },
      { th: t('data_column.created_at'), td: 'created_at', width: '20%' },
    ],
    staff: [
      { th: t('data_column.actor_name'), td: 'actor_name', width: '10%' },
      { th: t('data_column.actor_phone_number'), td: 'actor_phone_number', width: '12%' },
      { th: t('data_column.actor_role'), td: 'actor_role', width: '10%' },
      { th: t('data_column.content'), td: 'operation', width: '16%' },
      { th: t('data_column.owner_name'), td: 'grantee_name', width: '10%' },
      { th: t('data_column.owner_phone_number'), td: 'grantee_phone_number', width: '12%' },
      { th: t('data_column.owner_role'), td: 'grantee_role', width: '10%' },
      { th: t('data_column.created_at'), td: 'created_at', width: '12%' },
    ],
    user_mobilekey: [
      { th: t('data_column.building'), td: 'building_name', width: '15%' },
      { th: t('data_column.room'), td: 'json_destination.room', width: '12%' },
      { th: t('data_column.content'), td: 'operation', width: '23%' },
      { th: t('data_column.key_user_name'), td: 'actor_name', width: '12%' },
      { th: t('data_column.phone_number'), td: 'actor_phone_number', width: '15%' },
      { th: t('data_column.created_at'), td: 'created_at', width: '15%' },
    ],
  };

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  //디바운싱 사용 구분을 위해 debounce props 추가
  const changeFilterItem = (targetItem, debounce) => {
    setFilterItem({
      ...filterItem,
      ...targetItem,
    }, debounce);
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const initFilterItem = () => {
    setFilterItem({
      reportType: 'userkey',
      buildingName: '',
      // startAt: '',
      // endAt: '',
    });
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const selectReport = (reportItem) => {
    setSelectedReportItem(reportItem);
    setIsOpenReportDetailModal(true);
  };

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>{t('content_title.report')}</h3>
      </div>
      <div className='content-title'>
        <div className='excel-upload' onClick={() => exportDataToExcel()}>
          <img className='excel-logo' src='../assets/images/excel.png' alt='excel_logo'></img>
          <span>{t('button.report_excel_download')}</span>
        </div>
        <Filter
          columns={[
            {
              key: 'reportType',
              type: 'select',
              size: 'xlg',
              placeholder: 'Type',
              value: filterItem.reportType,
              action: changeFilterItem,
              selectItems: reportTypeList,
              selectItemKey: 'key',
              selectItemValue: 'value',
            },
             {
               key: 'startAt',
               type: 'datePicker',
               placeholder: '시작일자',
               value: filterItem.startAt,
               action: changeFilterItem,
               selectsStart: true,
               minDate: filterItem.endAt ? moment(filterItem.endAt).subtract(12, 'M').toDate() : '',
               maxDate: filterItem.endAt,
               endDate: filterItem.endAt,
               showTimeSelect: false,
               isRemoveButton: true,
             },
             {
               key: 'endAt',
               type: 'datePicker',
               placeholder: '종료일자',
               value: filterItem.endAt,
               action: changeFilterItem,
               selectsEnd: true,
               minDate: filterItem.startAt,
               maxDate: filterItem.startAt ? moment(filterItem.startAt).add(12, 'M').toDate() : moment().add(12, 'M').toDate(),
               startDate: filterItem.startAt,
               showTimeSelect: false,
               isRemoveButton: true,
             },
            {
              key: 'buildingName',
              size: 'md',
              placeholder: t('placeholder.building'),
              value: filterItem.buildingName,
              action: changeFilterItem,
              hidden: filterItem.reportType === 'staff',
            },
          ]}
          init={initFilterItem}
        />
      </div>
      <Table>
        <thead>
          <tr>
            <th width='8%'>{t('data_column.view')}</th>
            {reportTableConfig[filterItem.reportType].map((reportTable, index) => (
              <th key={index} width={reportTable.width}>{reportTable.th}</th>
            ))}
            <th width='5%'></th>
          </tr>
        </thead>
        <tbody>
          {
            reportListItems.length > 0 ?
              reportListItems.map((report, index) => (
                <tr key={index}>
                  <td className='action-button'>
                    <span onClick={() => selectReport(report)}><FontAwesomeIcon icon={faSearch}/></span>
                  </td>
                  {reportTableConfig[filterItem.reportType].map((reportTable, index) => (
                    <td key={index}>{reportListFormatter(report, reportTable.td)}</td>
                  ))}
                  <td></td>
                </tr>
              ))
              : <tr>
                  <td colSpan={reportTableConfig[filterItem.reportType].length + 2} className='no-list-data'>
                    {t('error_message.no_data')}
                  </td>
                </tr>
          }
        </tbody>
      </Table>
      <Pagination
        total={reportListTotal}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      />
      <ReportDetail
        isOpen={isOpenReportDetailModal}
        toggle={() => setIsOpenReportDetailModal(!isOpenReportDetailModal)}
        reportItem={selectedReportItem}
        reportType={filterItem.reportType}
      />
    </Fragment>
  );
};

export default ReportList;